import { Box } from '@chakra-ui/react';

import Guidance from 'features/Onboarding/components/Guidance';

import asBentoPage from '../../../../../../common/bento/hoc/asBentoPage';
import Accordion from '../../../../../../components/_core/Accordion';
import Button from '../../../../../../components/_core/Button';
import Heading from '../../../../../../components/_core/Heading';
import Text from '../../../../../../components/_core/Text';
import OBNavigation from '../../../../components/OBNavigation/OBNavigation';
import locales from './locales';

interface BeneficiariesSummaryProps {
  onNext: () => void;
  onSkip: () => void;
  companyName: string;
  showSkipButton: boolean;
}

const BeneficiariesSummary = asBentoPage<BeneficiariesSummaryProps>(
  ({ companyName, Layout, onNext, onPrev, onSkip, showSkipButton }) => {
    return (
      <Layout nav={<OBNavigation onPrev={onPrev} />}>
        <Heading marginBottom="space-24" size="lg">
          {locales.heading}
        </Heading>

        <Text marginBottom="space-40">
          {locales.formatString(locales.description, { companyName })}
        </Text>

        <Guidance steps={[...locales.steps]} />

        <Accordion marginBottom="space-48" marginTop="space-48">
          <Accordion.Item title={locales.accordion.title}>
            <Accordion.Text>{locales.accordion.text}</Accordion.Text>
          </Accordion.Item>
        </Accordion>

        <Button marginBottom="space-16" onClick={onNext} width="full">
          {locales.buttons.cta}
        </Button>
        {showSkipButton ? (
          <Box textAlign="center">
            <Button onClick={onSkip} variant="inline-secondary">
              {locales.buttons.skip}
            </Button>
          </Box>
        ) : null}
      </Layout>
    );
  },
);

export default BeneficiariesSummary;
